module.exports = __webpack_public_path__ + "img/23_15.bec9abc2.png";